import React from "react";
import { Grid } from "@mui/material";
import { ImageBaseUrl } from "../../Environment";
import { getSecureItem } from "../../utilsFunctions";
import "./NoObjectionCertificate.css";

const translations = {
  en: {
    divisionLabel: "Micro Finance Division",
    dateLabel: "Date:",
    title: "NO OBJECTION CERTIFICATE (NOC)",
    bodyPre: "This is to certify that customer",
    bodyLoanRef: "(Loan A/c No.:",
    bodyMid:
      ") has fully repaid the entire loan (Loan) availed from the company",
    bodyEnd: ".",
    customerName: "Customer Name: ",
    fatherHusbandName: "Father's / Husband's Name: ",
    loanAccountNo: "Loan Account No.: ",
    branch: "Branch: ",
    dues: "Dues: ",
    duesValue: "Nil",
    totalAmountPaid: "Total Amount Paid: ",
    closingNote:
      "As on this date, there are no outstanding dues on the above loan account. The company has no objection to closing this account.",
    onBehalfOf: "On behalf of:",
    customerSignature: "Customer's Signature",
    authorizedSignature: "Authorized Signature / Seal",
  },
  hi: {
    divisionLabel: "माइक्रो फाइनेंस डिवीजन",
    dateLabel: "दिनांक:",
    title: "NO OBJECTION CERTIFICATE (NOC)",
    bodyPre: "प्रमाणित किया जाता है कि ग्राहक",
    bodyLoanRef: "(लोन खाता सं.:",
    bodyMid: ") ने अपनी कंपनी",
    bodyMid2: "के संपूर्ण ऋण (Loan) का पूर्ण भुगतान कर दिया है",
    bodyEnd: "।",
    customerName: "ग्राहक का नाम: ",
    fatherHusbandName: "पति/पिता का नाम: ",
    loanAccountNo: "लोन खाता संख्या: ",
    branch: "शाखा (Branch): ",
    dues: "बकाया राशि (Dues): ",
    duesValue: "शून्य",
    totalAmountPaid: "कुल भुगतान की गई राशि: ",
    closingNote:
      "आज की तिथि में उक्त लोन खाते पर कोई बकाया नहीं है। कंपनी को इस खाते को बंद करने पर कोई आपत्ति नहीं है।",
    onBehalfOf: "कृते:",
    customerSignature: "ग्राहक के हस्ताक्षर",
    authorizedSignature: "अधिकृत हस्ताक्षर / मोहर",
  },
  ta: {
    divisionLabel: "மைக்ரோ ஃபைனான்ஸ் பிரிவு",
    dateLabel: "தேதி:",
    title: "NO OBJECTION CERTIFICATE (NOC)",
    bodyPre: "வாடிக்கையாளர்",
    bodyLoanRef: "(கடன் கணக்கு எண்:",
    bodyMid: ") அவர்கள் தமது",
    bodyMid2:
      "நிறுவனத்திடமிருந்து பெற்ற முழுக் கடனையும் (Loan) முழுமையாகச் செலுத்தி விட்டதாக இதன் மூலம் சான்றளிக்கப்படுகிறது",
    bodyEnd: ".",
    customerName: "வாடிக்கையாளர் பெயர்: ",
    fatherHusbandName: "தந்தை/கணவர் பெயர்: ",
    loanAccountNo: "கடன் கணக்கு எண்: ",
    branch: "கிளை (Branch): ",
    dues: "நிலுவைத் தொகை (Dues): ",
    duesValue: "இல்லை",
    totalAmountPaid: "மொத்தம் செலுத்தப்பட்ட தொகை: ",
    closingNote:
      "இன்றைய தேதி வரை மேற்கண்ட கடன் கணக்கில் எந்த நிலுவைத் தொகையும் இல்லை. இந்தக் கணக்கை மூடுவதற்கு நிறுவனத்திற்கு எந்த ஆட்சேபனையும் இல்லை.",
    onBehalfOf: "சார்பாக:",
    customerSignature: "வாடிக்கையாளர் கையொப்பம்",
    authorizedSignature: "அங்கீகரிக்கப்பட்ட கையொப்பம் / முத்திரை",
  },
  te: {
    divisionLabel: "మైక్రో ఫైనాన్స్ డివిజన్",
    dateLabel: "తేదీ:",
    title: "NO OBJECTION CERTIFICATE (NOC)",
    bodyPre: "కస్టమర్",
    bodyLoanRef: "(లోన్ ఖాతా సంఖ్య:",
    bodyMid: ") తన",
    bodyMid2:
      "కంపెనీ నుండి తీసుకున్న మొత్తం రుణాన్ని (Loan) పూర్తిగా చెల్లించినట్లు ఇందుమూలంగా ధృవీకరించడమైనది",
    bodyEnd: ".",
    customerName: "కస్టమర్ పేరు: ",
    fatherHusbandName: "తండ్రి/భర్త పేరు: ",
    loanAccountNo: "లోన్ ఖాతా సంఖ్య: ",
    branch: "శాఖ (Branch): ",
    dues: "బకాయి మొత్తం (Dues): ",
    duesValue: "శూన్యం",
    totalAmountPaid: "మొత్తం చెల్లించిన మొత్తం: ",
    closingNote:
      "నేటి తేదీ నాటికి పై లోన్ ఖాతాలో ఎటువంటి బకాయి లేదు. ఈ ఖాతాను మూసివేయడానికి కంపెనీకి ఎటువంటి అభ్యంతరం లేదు.",
    onBehalfOf: "తరపున:",
    customerSignature: "కస్టమర్ సంతకం",
    authorizedSignature: "అధీకృత సంతకం / సీలు",
  },
  ml: {
    divisionLabel: "മൈക്രോ ഫിനാൻസ് ഡിവിഷൻ",
    dateLabel: "തീയതി:",
    title: "NO OBJECTION CERTIFICATE (NOC)",
    bodyPre: "ഉപഭോക്താവ്",
    bodyLoanRef: "(ലോൺ അക്കൗണ്ട് നമ്പർ:",
    bodyMid: ") തന്റെ",
    bodyMid2:
      "കമ്പനിയിൽ നിന്ന് എടുത്ത മുഴുവൻ വായ്പയും (Loan) പൂർണ്ണമായി തിരിച്ചടച്ചു എന്ന് ഇതിനാൽ സാക്ഷ്യപ്പെടുത്തുന്നു",
    bodyEnd: ".",
    customerName: "ഉപഭോക്താവിന്റെ പേര്: ",
    fatherHusbandName: "പിതാവിന്റെ/ഭർത്താവിന്റെ പേര്: ",
    loanAccountNo: "ലോൺ അക്കൗണ്ട് നമ്പർ: ",
    branch: "ശാഖ (Branch): ",
    dues: "കുടിശ്ശിക (Dues): ",
    duesValue: "ഇല്ല",
    totalAmountPaid: "ആകെ അടച്ച തുക: ",
    closingNote:
      "ഇന്നത്തെ തീയതി പ്രകാരം മേൽപ്പറഞ്ഞ ലോൺ അക്കൗണ്ടിൽ കുടിശ്ശിക ഒന്നും ഇല്ല. ഈ അക്കൗണ്ട് അവസാനിപ്പിക്കുന്നതിന് കമ്പനിക്ക് എതിർപ്പില്ല.",
    onBehalfOf: "വേണ്ടി:",
    customerSignature: "ഉപഭോക്താവിന്റെ ഒപ്പ്",
    authorizedSignature: "അധികൃത ഒപ്പ് / മുദ്ര",
  },
  kn: {
    divisionLabel: "ಮೈಕ್ರೋ ಫೈನಾನ್ಸ್ ವಿಭಾಗ",
    dateLabel: "ದಿನಾಂಕ:",
    title: "NO OBJECTION CERTIFICATE (NOC)",
    bodyPre: "ಗ್ರಾಹಕ",
    bodyLoanRef: "(ಸಾಲ ಖಾತೆ ಸಂಖ್ಯೆ:",
    bodyMid: ") ಅವರು ತಮ್ಮ",
    bodyMid2:
      "ಕಂಪನಿಯಿಂದ ಪಡೆದ ಸಂಪೂರ್ಣ ಸಾಲವನ್ನು (Loan) ಸಂಪೂರ್ಣವಾಗಿ ಮರುಪಾವತಿಸಿದ್ದಾರೆ ಎಂದು ಇದರ ಮೂಲಕ ಪ್ರಮಾಣೀಕರಿಸಲಾಗಿದೆ",
    bodyEnd: ".",
    customerName: "ಗ್ರಾಹಕರ ಹೆಸರು: ",
    fatherHusbandName: "ತಂದೆ/ಪತಿಯ ಹೆಸರು: ",
    loanAccountNo: "ಸಾಲ ಖಾತೆ ಸಂಖ್ಯೆ: ",
    branch: "ಶಾಖೆ (Branch): ",
    dues: "ಬಾಕಿ ಮೊತ್ತ (Dues): ",
    duesValue: "ಶೂನ್ಯ",
    totalAmountPaid: "ಒಟ್ಟು ಪಾವತಿಸಿದ ಮೊತ್ತ: ",
    closingNote:
      "ಇಂದಿನ ದಿನಾಂಕದವರೆಗೆ ಮೇಲಿನ ಸಾಲ ಖಾತೆಯಲ್ಲಿ ಯಾವುದೇ ಬಾಕಿ ಇಲ್ಲ. ಈ ಖಾತೆಯನ್ನು ಮುಚ್ಚಲು ಕಂಪನಿಗೆ ಯಾವುದೇ ಆಕ್ಷೇಪಣೆ ಇಲ್ಲ.",
    onBehalfOf: "ಪರವಾಗಿ:",
    customerSignature: "ಗ್ರಾಹಕರ ಸಹಿ",
    authorizedSignature: "ಅಧಿಕೃತ ಸಹಿ / ಮುದ್ರೆ",
  },
  mr: {
    divisionLabel: "मायक्रो फायनान्स विभाग",
    dateLabel: "दिनांक:",
    title: "NO OBJECTION CERTIFICATE (NOC)",
    bodyPre: "ग्राहक",
    bodyLoanRef: "(कर्ज खाते क्र.:",
    bodyMid: ") यांनी त्यांच्या",
    bodyMid2:
      "कंपनीकडून घेतलेल्या संपूर्ण कर्जाची (Loan) पूर्ण परतफेड केली आहे, याद्वारे प्रमाणित करण्यात येते",
    bodyEnd: ".",
    customerName: "ग्राहकाचे नाव: ",
    fatherHusbandName: "वडील/पतीचे नाव: ",
    loanAccountNo: "कर्ज खाते क्रमांक: ",
    branch: "शाखा (Branch): ",
    dues: "थकबाकी (Dues): ",
    duesValue: "शून्य",
    totalAmountPaid: "एकूण भरलेली रक्कम: ",
    closingNote:
      "आजच्या तारखेपर्यंत वरील कर्ज खात्यावर कोणतीही थकबाकी नाही. हे खाते बंद करण्यास कंपनीची कोणतीही हरकत नाही.",
    onBehalfOf: "वतीने:",
    customerSignature: "ग्राहकाची स्वाक्षरी",
    authorizedSignature: "अधिकृत स्वाक्षरी / शिक्का",
  },
  gu: {
    divisionLabel: "માઇક્રો ફાઇનાન્સ વિભાગ",
    dateLabel: "તારીખ:",
    title: "NO OBJECTION CERTIFICATE (NOC)",
    bodyPre: "ગ્રાહક",
    bodyLoanRef: "(લોન ખાતા નં.:",
    bodyMid: ") એ પોતાની",
    bodyMid2:
      "કંપની પાસેથી લીધેલી સંપૂર્ણ લોન (Loan) ની સંપૂર્ણ ચુકવણી કરી દીધી છે, તેની આથી પ્રમાણિત કરવામાં આવે છે",
    bodyEnd: ".",
    customerName: "ગ્રાહકનું નામ: ",
    fatherHusbandName: "પિતા/પતિનું નામ: ",
    loanAccountNo: "લોન ખાતા નંબર: ",
    branch: "શાખા (Branch): ",
    dues: "બાકી રકમ (Dues): ",
    duesValue: "શૂન્ય",
    totalAmountPaid: "કુલ ચૂકવેલ રકમ: ",
    closingNote:
      "આજની તારીખ સુધીમાં ઉપરોક્ત લોન ખાતામાં કોઈ બાકી રકમ નથી. આ ખાતું બંધ કરવા સામે કંપનીને કોઈ વાંધો નથી.",
    onBehalfOf: "વતી:",
    customerSignature: "ગ્રાહકની સહી",
    authorizedSignature: "અધિકૃત સહી / સિક્કો",
  },
};

// Fonts good for rendering Indic scripts consistently in print/PDF.
const fontStackByLang = {
  en: "'Lato', Arial, sans-serif",
  hi: "'Noto Sans Devanagari', 'Mangal', sans-serif",
  mr: "'Noto Sans Devanagari', 'Mangal', sans-serif",
  ta: "'Noto Sans Tamil', 'Latha', sans-serif",
  te: "'Noto Sans Telugu', 'Gautami', sans-serif",
  ml: "'Noto Sans Malayalam', 'Kartika', sans-serif",
  kn: "'Noto Sans Kannada', 'Tunga', sans-serif",
  gu: "'Noto Sans Gujarati', 'Shruti', sans-serif",
};

const formatDDMMYYYY = (value) => {
  if (!value) return { dd: "", mm: "", yyyy: new Date().getFullYear() };
  const d = new Date(value);
  if (isNaN(d.getTime()))
    return { dd: "", mm: "", yyyy: new Date().getFullYear() };
  return {
    dd: String(d.getDate()).padStart(2, "0"),
    mm: String(d.getMonth() + 1).padStart(2, "0"),
    yyyy: d.getFullYear(),
  };
};

const Blank = ({ value, minWidth = 220 }) => (
  <strong className="noc-blank" style={{ minWidth }}>
    {value || "\u00A0"}
  </strong>
);

const getAddress = (address) =>
  [
    address?.AddressStreet,
    address?.AddressLandmark,
    address?.AddressCity,
    address?.AddressState,
    address?.AddressPincode,
  ]
    .filter(Boolean)
    .join(", ");

const customerAddress = (address) =>
  [address?.AddressStreet, address?.AddressLandmark].filter(Boolean).join(", ");

const customerAddress2 = (address) =>
  [address?.AddressCity, address?.AddressState, address?.AddressPincode]
    .filter(Boolean)
    .join(", ");

export const NoObjectionCertificate = React.forwardRef(
  (
    {
      selectedBranch = {},
      branchAddress,
      data,
      language = "en",
      signatureType,
      printRef,
    },
    forwardedRef,
  ) => {
    const t = translations[language] || translations.en;
    const isDefaultSignature = signatureType === "default";
    const countryCode = getSecureItem("country")?.code;
    const countryCurrency = getSecureItem("country")?.symbol;

    const companyData = data?.company;
    const customerData = data?.customer;

    const customerSignaturePic = data?.customer?.proofs?.find(
      (p) => p.proofType === "uploadSignature",
    )?.proofImagePath;
    const AdminSignature =
      companyData?.users?.find(
        (u) =>
          u.userType === "Admin" &&
          u.branchId === data?.customer?.branchId &&
          u.userSignaturePath,
      )?.userSignaturePath ||
      companyData?.users?.find(
        (u) => u.userType === "superAdmin" && u.userSignaturePath,
      )?.userSignaturePath ||
      null;

    const { summary, loanId, updatedAt } = data;

    const { dd, mm, yyyy } = formatDDMMYYYY(updatedAt);

    return (
      <div
        ref={printRef || forwardedRef}
        className="noc-page"
        style={{ fontFamily: fontStackByLang[language] || fontStackByLang.en }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            paddingX={2}
            style={{ border: "1px solid black" }}
          >
            <div className="header-left">
              {companyData?.profilePic ? (
                <img
                  src={
                    getSecureItem("loggedinUserCompany") == "1365"
                      ? "https://i.imghippo.com/files/CCD2780qQ.jpeg"
                      : `${ImageBaseUrl}${companyData?.profilePic}`
                  }
                  alt="Logo"
                  className="logo"
                />
              ) : (
                <div
                  style={{
                    height: "120px",
                  }}
                ></div>
              )}
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={8}
            md={8}
            paddingX={2}
            style={{ border: "1px solid black", borderRightWidth: "0px" }}
          >
            <div className="header-right">
              <h1>{companyData?.companyName}</h1>
              <p>
                <strong>Address: </strong>{" "}
                {branchAddress ? branchAddress : getAddress(companyData)}
                <br />
                <strong>GSTIN: </strong> {companyData?.GstIn || ""} |{" "}
                <strong>CIN: </strong> {companyData?.CIN || ""} |{" "}
                <strong>Website: </strong> {companyData?.companyWebsite || ""}
                <br />
                <strong>Mobile No: </strong> {companyData?.phone}{" "}
                <strong>| Email ID: </strong> {companyData?.companyMail}
              </p>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            paddingX={2}
            style={{ border: "1px solid black", borderLeftWidth: "0px" }}
          />
        </Grid>

        <div style={{marginTop: "50px", marginRight: "50px"}} align="right">
          <span>
            <strong>{t.dateLabel}</strong> <Blank value={dd} minWidth={28} /> /{" "}
            <Blank value={mm} minWidth={28} /> /{" "} <Blank value={yyyy} minWidth={28} />
          </span>
        </div>

        <h2 className="title">{t.title}</h2>

        <p style={{ marginBlock: "30px", marginInline: "50px" }}>
          {t.bodyPre}{" "}
          <Blank
            value={customerData?.firstName + " " + customerData?.lastName}
          />{" "}
          {t.bodyLoanRef} <Blank value={loanId} minWidth={160} />
          {t.bodyMid}{" "}
          {t.bodyMid2 ? <strong>{companyData?.companyName}</strong> : null}{" "}
          {t.bodyMid2}
          {!t.bodyMid2 ? <strong>{companyData?.companyName}</strong> : null}
          {t.bodyEnd}
        </p>

        <div style={{ marginInline: "50px" }}>
          <div className="noc-field-row">
            <span className="noc-field-label">{t.customerName}</span>
            <Blank
              value={customerData?.firstName + " " + customerData?.lastName}
              minWidth={320}
            />
          </div>
          <div className="noc-field-row">
            <span className="noc-field-label">{t.fatherHusbandName}</span>
            <Blank value={customerData?.fatherName} minWidth={320} />
          </div>
          <div className="noc-field-row">
            <span className="noc-field-label">{t.loanAccountNo}</span>
            <Blank value={loanId} minWidth={320} />
          </div>
          <div className="noc-field-row">
            <span className="noc-field-label">{t.branch}</span>
            <Blank value={selectedBranch?.label} minWidth={320} />
          </div>
          <div className="noc-field-row">
            <span className="noc-field-label">{t.dues}</span>
            <Blank value={t.duesValue} minWidth={320} />
          </div>
          <div className="noc-field-row">
            <span className="noc-field-label">{t.totalAmountPaid}</span>
            <Blank value={`${countryCurrency} ${summary?.totalAmountPaid ?? 0}`} minWidth={320} />
          </div>
        </div>

        <p style={{ marginInline: "50px" }} className="noc-closing">
          {t.closingNote}
        </p>

        <div align="right" style={{marginTop: "50px", marginRight: "50px"}}>
          <p>
            <span>{t.onBehalfOf}</span>
            <br />
            <strong>{companyData?.companyName}</strong>
          </p>
        </div>

        <div className="noc-signatures">
          <div className="noc-signature-block noc-signature-left">
            {isDefaultSignature && customerSignaturePic ? (
              <img
                src={customerSignaturePic}
                alt="signature"
                className="noc-sign-image"
              />
            ) : (
              <div className="noc-sign-line" />
            )}
            <p>{t.customerSignature}</p>
          </div>

          <div className="noc-signature-block noc-signature-right">
            {isDefaultSignature && AdminSignature ? (
              <img
                src={AdminSignature}
                alt="signature"
                className="noc-sign-image"
              />
            ) : (
              <div className="noc-sign-line" />
            )}
            <p>{t.authorizedSignature}</p>
          </div>
        </div>
      </div>
    );
  },
);

NoObjectionCertificate.displayName = "NoObjectionCertificate";
